export const parseThroughputUsage = (input, mode, bqnId) => {
  const [header, ...rows] = input.trim("\n").split("\n");
  const headerAttrs = header.trim("s").split(/\s+/);
  const indexAttrMap = headerAttrs.reduce((acc, value, index) => {
    acc[index] = value;
    return acc;
  }, {});
  return rows.reduce((acc, row) => {
    if (row.trim("s").length > 0) {
      const rowAtrs = row.trim("s").split(/\s+/);
      const item = rowAtrs.reduce((accItem, attr, index) => {
        if (indexAttrMap[index] === "BQN") {
          accItem["bqn"] = attr;
        } else if (indexAttrMap[index] === "INTERFACE") {
          accItem["name"] = attr;
        } else if (indexAttrMap[index] === "BYTES-RX-Mbps") {
          accItem["rx"] = parseFloat(attr);
        } else if (indexAttrMap[index] === "BYTES-TX-Mbps") {
          accItem["tx"] = parseFloat(attr);
        }
        return accItem;
      }, {});
      acc.push(item);
    }
    return acc;
  }, []);
};
